import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import type { ChangeEvent, FormEvent, KeyboardEvent, MouseEvent } from 'react'
// import errorIcon from '../../assets/icons/ico_error_text.svg'
// import inputStyles from '../../styles/input.module.css'
import styles from './forgotPassword.module.css'

type ForgotPasswordFormValues = {
  email: string
  [key: string]: string
}

// type ForgotPasswordFormErrors = {
//   email?: string
//   general?: string
//   [key: string]: string | undefined
// }

interface ForgotPasswordFormProps {
  values: ForgotPasswordFormValues
  // errors: ForgotPasswordFormErrors
  // generalError: string | undefined
  isLoading: boolean
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleSubmit: (e: FormEvent) => void
  onLinkClick: (page: string) => void
}

const ForgotPasswordForm = ({
  values,
  // errors,
  // generalError,
  isLoading,
  handleChange,
  handleSubmit,
  onLinkClick,
}: ForgotPasswordFormProps) => {
  const handleKeyDown = (event: KeyboardEvent, handler: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handler()
    }
  }
  return (
    <form
      className={styles.form}
      onSubmit={(e: FormEvent) => {
        e.preventDefault()
        e.stopPropagation()
        handleSubmit(e)
      }}
    >
      {/* <div className={inputStyles.errorTextWrapper}>
        {generalError && <img src={errorIcon} alt="error" />}
        <p className={inputStyles.errorText}>{generalError}</p>
      </div> */}

      <Input id="email" type="text" placeholder="Email" value={values.email} onChange={handleChange} disabled={isLoading} />

      {/* <div className={inputStyles.errorTextWrapper}>
        {errors.email && <img src={errorIcon} alt="error" />}
        <p className={inputStyles.errorText}>{errors.email}</p>
      </div> */}

      <Button
        type="button"
        variant="fill"
        size="large"
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
          handleSubmit(e as unknown as FormEvent)
        }}
        onKeyDown={(e) =>
          handleKeyDown(e, () => {
            e.preventDefault()
            handleSubmit(e as unknown as FormEvent)
          })
        }
        disabled={isLoading}
        style={{ opacity: isLoading ? 0.7 : 1, cursor: isLoading ? 'not-allowed' : 'pointer', padding: '16px 24px' }}
      >
        {isLoading ? 'Sending...' : 'Send'}
      </Button>

      <button
        type="button"
        className={styles.linkBtn}
        onClick={() => onLinkClick('login')}
        onKeyDown={(e) => handleKeyDown(e, () => onLinkClick('login'))}
      >
        Back to login
      </button>
    </form>
  )
}

export default ForgotPasswordForm
